import React, { useEffect, useState, useRef } from "react";
import Loading from "../../../../../Others/Loading";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { onlinePaymentDetails } from "../../../../../Redux/Actions/userActions";
import { saveBillDetails } from "../../../../../Redux/Actions/userActions";
const url = process.env.React_App_Api_url;

const getPaytmTxnDetails = async (orderID) => {
  try {
    const response = await fetch(`${url}/txnstatus/${orderID}`);
    if (!response.ok) {
      throw new Error("request failed");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("Error at getting paytm txn details", error);
  }
};

const PaymentAwait = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [txnStatus, setTxnStatus] = useState(null);
  const timer = useRef(false);

  const txnSuccess = (orderID, data) => {
    try {
      dispatch(
        onlinePaymentDetails({
          paymentMethod: "PayTM",
          paytmOrderId: orderID,
          paytmTxnNo: data?.data?.txnId,
        })
      );
      const bill = localStorage.getItem("BILL");
      if (!bill || bill === "invalid") {
        throw new Error("SOMETHING WENT WRONG");
      }

      dispatch(saveBillDetails(JSON.parse(bill)));
      localStorage.setItem("OID", "invalid");
      localStorage.setItem("BILL", "invalid");
      return new Promise((resolve) => resolve());
    } catch (error) {
      return new Promise((_, reject) => reject(error));
    }
  };
  const getTxnStatus = (orderID) => {
    getPaytmTxnDetails(orderID).then((data) => {
      switch (data?.data?.resultInfo?.resultCode) {
        case "01":
          txnSuccess(orderID, data)
            .then(() => navigate("/place-order", { replace: true }))
            .catch((error) => console.log(error));
          break;
        case "402":
          if (timer.current) {
            clearTimeout(timer);
          }
          timer.current = setTimeout(() => {
            getTxnStatus(orderID);
          }, 5000);

          break;
        default:
          break;
      }

      setTxnStatus(data?.data?.resultInfo?.resultMsg);
    });
  };

  useEffect(() => {
    //execute only when there is orderID in the db
    let orderID = localStorage.getItem("OID") || null;
    if (!orderID || orderID === "invalid") {
      navigate("/home", { replace: true });
      return;
    }
    getTxnStatus(orderID);
  }, []);

  return txnStatus ? (
    <div>
      <h1>{txnStatus}</h1>
      <p>Please don't refresh or go back on this page</p>
    </div>
  ) : (
    <Loading />
  );
};

export default PaymentAwait;
